import React from 'react';

import usePredefineOptions from '../../../../hooks/usePredefineOptions';
import RequestsHistory from '../../../../../../ai-studio/requests-history/RequestsHistory';

import scss from './Requests.module.scss';

function Requests() {
  const actionOptions = usePredefineOptions();

  return (
    <div className={scss.requestsHistoryWrapper}>
      <RequestsHistory actionOptions={actionOptions.options} />
    </div>
  );
}

export default Requests;
